import { gql, useQuery } from '@apollo/client';

const gqlQueryFilter = gql`
    query overviewUserState {
        CITRIN_MGT_overviewUserState @client
    }
`;
const typeName = 'CITRIN_MGT_overviewUserState';

export type OverviewState = {
    search?: string;
    page?: number;
};

const initialState: OverviewState = {
    search: '',
    page: 1,
};

export const useOverviewLinkState = (): [OverviewState, (newState: OverviewState) => void] => {
    const { data, client } = useQuery(gqlQueryFilter, { fetchPolicy: 'cache-first' });
    const setState = (newState: OverviewState) => {
        client.writeQuery({
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewUserState: {
                    value: newState,
                    __typename: typeName,
                },
            },
        });
    };
    return [data?.CITRIN_MGT_overviewUserState?.value ?? initialState, setState];
};

export default {
    defaults: [
        {
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewUserState: {
                    value: initialState,
                    __typename: 'CITRIN_MGT_overviewUserState',
                },
            },
        },
    ],
};
